import React, { useEffect, useState } from "react";
import useAuth from "../../hooks/useAuth";
import axios from "axios";
import { BACKEND_BASE_URL, BASE_URL, ConfigInputType, isEmpty, SUCCESS } from "../../constants/Constants";
import { Button, Grid } from "@mui/material";
import CustomDataGrid from "../../global/CustomDataGrid";
import { ConfigEditView } from "./ConfigEditView";
import DialogBox from "../../global/DialogBox";


const Configuration = () => {

    const { activeShopHash, authUser, updateConfiguration } = useAuth();

    const [listConfigs, setListConfigs] = useState([]);
    const [loader, setLoader] = useState(false);

    const INITIAL_CONFIGS = {
        id: "",
        configName: "",
        configNameStr: "",
        employeeName: "",
        prefix: "",
        val: "",
        displayVal: "",
        comments: "",
        type: 0,
        valType: 0,
        allowed: true,
        allowedStr: "",
    };
    const [configs, setConfigs] = useState(INITIAL_CONFIGS);
    const [selectedImage, setSelectedImage] = useState('');
    const [imageSelectedError, setImageSelectedError] = useState(false);
    const [uploadedDocument, setUploadedDocument] = useState("");
    const [listItems, setListItems] = useState([]);
    const [mapItems, setMapItems] = useState(new Map());
    const [showDialog, setShowDialog] = useState(false);


    const handleDialogClose = () => {
        // console.log("handleDialogClose");
        setConfigs(INITIAL_CONFIGS);
        setShowDialog(false);
        setSelectedImage('');
        setImageSelectedError(false);
        setUploadedDocument('');
    };

    const handleCellClick = (param, event) => {
        if (event.row.valType === ConfigInputType.ATTACHMENT && !isEmpty(event.row.val)) {
            setSelectedImage(BASE_URL + "files/" + event.row.val)
        }
        setShowDialog(true);
        setConfigs({
            ...event.row,
        });
    };

    useEffect(() => {
        showAllConfigs();
    }, []);

    const showAllConfigs = async () => {
        try {
            setLoader(true);
            const data = {
                payLoad: {
                    apiToken: authUser.apiToken,
                    shopHash: activeShopHash.id,
                }
            }
            const response = await axios.post(`${BACKEND_BASE_URL}show-all-configs`, data);
            if (response.data.status === SUCCESS) {
                setListConfigs(response?.data?.payLoad?.datas ?? []);
            } else {
                setListConfigs([]);
            }
        } catch (err) {
            console.error("showAllConfigs", err);
        } finally {
            setLoader(false);
        }
    }

    const getUpdatedVal = (valType, defVal) => {
        if (valType === ConfigInputType.LIST) {
            return listItems;
        } else if (valType === ConfigInputType.MAP) {
            return Object.fromEntries(mapItems);
        }
        return defVal;
    }

    const handleUpdateConfigs = async () => {
        try {
            const mVal = getUpdatedVal(configs.valType, configs.val);
            const data = {
                payLoad: {
                    apiToken: authUser.apiToken,
                    shopHash: activeShopHash.id,
                    ...configs,
                    val: mVal,
                }
            };
            setLoader(true);
            setShowDialog(false);
            const response = await axios.post(`${BACKEND_BASE_URL}persist-configuration`, data);
            if (response.data.status === SUCCESS) {
                updateConfiguration(configs.configName, mVal);
                showAllConfigs();
            }
            handleDialogClose();
            setMapItems(new Map());
            setListItems([]);
        } catch (err) {
            console.error("handleUpdateConfigs", err);
        } finally {
            setLoader(false);
        }
    };

    const columns = [
        { field: 'employeeName', headerName: 'Emp. Name', width: 150 },
        { field: 'configName', headerName: 'Config Name', width: 210 },
        { field: 'displayVal', headerName: 'Value', width: 630 },
        {
            field: "edit",
            headerName: "Edit",
            width: 90,
            renderCell: (cellValues) => {
                return (
                    <Button variant="contained"
                        color="primary"
                        onClick={(event) => handleCellClick(event, cellValues)}
                    >Edit</Button>
                );
            }
        }
    ]

    const renderDialogAction = () => {
        return (
            <React.Fragment>
                <Button variant="contained" color="primary" onClick={handleUpdateConfigs}>
                    Update
                </Button>
                <Button variant="contained" color="primary" onClick={handleDialogClose}>
                    Dismiss
                </Button>
            </React.Fragment>
        );
    }

    return (
        <>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <CustomDataGrid
                        getRowId={row => row.id}
                        rows={listConfigs}
                        columns={columns}
                        loading={loader}
                        title="Configuration List"

                    /></Grid>
                <DialogBox
                    showDialog={showDialog}
                    title={"Update Configuration"}
                    onClose={handleDialogClose}
                    dialogContent={
                        <ConfigEditView
                            configs={configs}
                            setConfigs={setConfigs} selectedImage={selectedImage}
                            setSelectedImage={setSelectedImage}
                            setUploadedDocument={setUploadedDocument}
                            imageSelectedError={imageSelectedError}
                            setImageSelectedError={setImageSelectedError}
                            listItems={listItems}
                            mapItems={mapItems}
                            setListItems={setListItems}
                            setMapItems={setMapItems}
                        />
                    }
                    dialogActions={renderDialogAction()}
                ></DialogBox>
            </Grid>
        </>
    )
}
export { Configuration };